import {
  DEFAULT_TENANT_ID,
  findTenantIdByAlias,
  getTenantById,
  CLIENT_ID_TO_TENANT
} from '../config/tenants'

const TENANT_STORAGE_KEY = 'sso_tenant_id'

export const persistTenantId = (tenantId) => {
  if (!tenantId) return
  sessionStorage.setItem(TENANT_STORAGE_KEY, tenantId)
  // Keep legacy flag for any leftover readers during rollout
  sessionStorage.setItem('isMiTienda', String(tenantId === 'mi-tienda'))
}

export const readPersistedTenantId = () => sessionStorage.getItem(TENANT_STORAGE_KEY)

/**
 * Resolve tenant from launch query params / session.
 * Priority: client_id map → client slug → persisted → default manda2
 */
export const resolveTenant = ({
  clientId = null,
  clientSlug = null,
  persistedId = null
} = {}) => {
  const fromClientId = clientId
    ? (CLIENT_ID_TO_TENANT[clientId] || findTenantIdByAlias(clientId))
    : null
  const fromSlug = clientSlug ? findTenantIdByAlias(clientSlug) : null
  const tenantId = fromClientId || fromSlug || persistedId || DEFAULT_TENANT_ID
  return getTenantById(tenantId)
}

export const resolveTenantFromWindow = () => {
  const queryParams = new URLSearchParams(window.location.search)
  const clientId = queryParams.get('client_id') || sessionStorage.getItem('client_id')
  const clientSlug = queryParams.get('client')
  const tenant = resolveTenant({
    clientId,
    clientSlug,
    persistedId: readPersistedTenantId()
  })
  if (clientId || clientSlug) {
    persistTenantId(tenant.id)
  }
  return tenant
}

export const loginButtonClassName = (tenant, base = 'button btn btn-login w-100') =>
  base + (tenant?.themeClass ? ` ${tenant.themeClass}` : '')
